import { render, staticRenderFns } from "./StatutoryReportSetupGrid.vue?vue&type=template&id=38654799"
import script from "./StatutoryReportSetupGrid.vue?vue&type=script&lang=js"
export * from "./StatutoryReportSetupGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports